module.exports = __webpack_public_path__ + "c_static/img/1-4电脑淘宝购物车.0060929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/4-回购特卖入口/1-4电脑淘宝购物车.jpg
// module id = 6pVl
// module chunks = 33